module.exports = __webpack_public_path__ + "5dc33ac0d6a50ef99ff7bd3b8d1a32db.MP3";